<app-table [columns]="columns" [data]="networks" [settings]="settings" [loading]="loadingNetworks">
    <ng-template #field let-item="item">
        <a href="/v2/networks/{{item.id}}">{{ item.name }}</a>
    </ng-template>
</app-table>
